<template>
	<el-container id="test" v-loading="test_load">
		<div class="location">
			<p>当前位置：</p>
			<p class="item" v-for="(item,index) in page_location" :key="index" @click="jumpPage(item)">{{item.title}} &gt;</p>
			{{test_tit}}
		</div>
		<div class="testCon">
			<div class="test_tit">
				<h1 class="titCon">{{test_tit}}</h1>
				<div class="count">
                    <p style="color:#000">本次考试您的分数是：<span style="color:red;font-size: 22px;font-weight: 700;">{{fenshu}}</span> </p>
				</div>
			</div>
			<el-form :model="testForm">
				<!-- {{formal}} -->
				<div v-for="(item,index) in formal" :key="index">
					<div class="big_question" v-if="item.type!='universal'">
						<!-- {{formal}}
						{{key}} -->
						<div class="big_qs_tit">
							<font class="qiZh">{{$selfjs.qiZh(index+1)}}、</font>
							<font class="headline">{{item.headline==''?timuleixing[item.type]:item.headline}}</font>
							<!-- <font class="big_qs_count">（共{{item.list.length}}题）</font> -->
						</div>
						<ul :class="item.type">
							<li :class="item.type+index+ti_index" v-for="(tiObj,ti_index) in item.list" v-if="item.list.length" :key="ti_index">
								<p><font>{{(ti_index+1)}}.</font><span class="sp" v-html="tiObj.title.replace(/\n/g, '<br>').replace(/\ /g, '&nbsp;')"></span>（{{tiObj.score}}分）</p>
								<p class="question_img"><img @click="handlePictureCardPreview(tiObj.question_img)" v-if="tiObj.question_img!=''" :src="ali_oss+tiObj.question_img" alt=""></p>
								<dl class="pr" v-if="item.type=='single'">
                    	            <div class="mask"></div>
									<el-form-item v-for="(chObj,ch_index) in tiObj.choices" :key="ch_index">
										<el-radio-group disabled v-model="tiObj.exam_answer.answer" >
											<el-radio :label="chObj.flag">
												{{chObj.flag}}.
												<img v-if="chObj.img" @click.prevent.stop="handlePictureCardPreview(chObj.img)" :src="ali_oss+chObj.img">
												{{chObj.content}}
											</el-radio>
										</el-radio-group>
									</el-form-item>
								</dl>
								<dl class="pr" v-if="item.type=='multiple'">
                    	            <div class="mask"></div>
									<el-form-item>
										<el-checkbox-group v-model="tiObj.value">
											<el-checkbox disabled v-for="(chObj,ch_index) in tiObj.choices" :key="ch_index" :label="chObj.flag" :name="item.type+ti_index+ch_index">{{chObj.flag+'. '+chObj.content}}</el-checkbox>
										</el-checkbox-group>
									</el-form-item>
								</dl>
								<dl class="pr" v-if="item.type=='judgement'">
                    	            <div class="mask"></div>
									<el-form-item>
										<el-radio-group v-model="tiObj.exam_answer.answer">
											<el-radio disabled label="对"></el-radio>
											<el-radio disabled label="错"></el-radio>
										</el-radio-group>
									</el-form-item>
								</dl>
								<dl v-if="item.type=='fill'||item.type=='other1'||item.type=='other2'">
									<span class="zhengque" style="margin-right: 8px;border-radius: 3px;font-size: 14px;padding: 2px 5px;background-color: rgb(109, 167, 226);color: rgb(255, 255, 255);">考生回答：</span>{{tiObj.exam_answer.answer}}
								</dl>
								<div v-if="tiObj.exam_img.length!=0"><span class="zhengque">考生图片</span>
									<p class="question_img"><img @click="handlePictureCardPreview(img.user_img)" :src="ali_oss+img.user_img" alt="" v-for="(img,imgind) in tiObj.exam_img" :key="imgind"></p>
								</div>
								<dl v-if="item.type=='open'">
									<el-form-item v-for="ch_index in tiObj.fill_count" :key="ch_index">
										<el-input type="textarea" v-model="tiObj.exam_answer.answer" autocomplete="off" readonly></el-input>
									</el-form-item>
								</dl>
								<div class="daan" v-if="item.type=='multiple'||item.type=='fill'||item.type=='other1'||item.type=='other2'"><span class="zhengque">正确答案</span>{{tiObj.correct_answer.replace(/\|\|/g,"、")}}</div>
								<div class="daan" v-else><span class="zhengque">正确答案</span>{{tiObj.correct_answer}}</div>
								<div class="daan" v-if="tiObj.answer_img">
									<span class="zhengque">答案图片</span>
									<img v-if="tiObj.answer_img!=''" :src="ali_oss+tiObj.answer_img" alt="">
								</div>
								<div class="daan" v-if="tiObj.answer.analysis!=''"><span class="zhengque">答案解析</span><span  v-html="tiObj.answer.analysis.replace(/\n/g, '<br>').replace(/\ /g, '&nbsp;')"></span></div>
								<div v-if="tiObj.analyses.length" class="analyses_video">
									<div v-for="(analys_item,analys_i) in tiObj.analyses" :key="analys_i">
										<!-- :poster="analys_item.video.poster" -->
										<video style="width: 80%; margin: 30px 0;" controls>
    									    <source
    									        :src="analys_item.video.url"
    									        type="video/mp4">
    									    您的浏览器不支持视频标签。
    									</video>
									</div>
								</div>
								<div class="defen" v-if="item.type=='fill'||item.type=='other1'||item.type=='other2'||item.type=='open'"><span class="defenspan">得分</span>{{tiObj.exam_answer.user_score|user_score_text}}<el-button @click="notify(tiObj)" type="warning" size="mini" class="notify"><i class="iconfont">&#xe63c;</i>反馈</el-button></div>
                    	        <div class="defen" v-else><span class="defenspan">得分</span>{{tiObj.exam_answer.user_score}} <el-button @click="notify(tiObj)" type="warning" size="mini" class="notify"><i class="iconfont">&#xe63c;</i>反馈</el-button> </div>
								<div class="daan" v-if="tiObj.exam_answer.opinion!=''"><span class="zhengque">批改意见</span>{{tiObj.exam_answer.opinion}}</div>
							</li>
						</ul>
					</div>
					<div v-else>
					<div class="big_question" v-for="(item,index) in item.list" :key="index+'sub'">
						<div>
							<div v-html="item.title" style="padding: 25px 0;"></div>
								<div v-for="(children_item,sub_i) in item.children" :key="children_item.id+'sub'+sub_i">
									<ul :class="children_item.type">
										<li :class="'universal'+index+sub_i">
											<p><font>{{(children_item.universal_sort)}}.</font><span class="sp" v-html="children_item.title.replace(/\n/g, '<br>')"></span>（{{children_item.score}}分）</p>
											<p v-if="children_item.question_img" class="question_img">
												<img :src="ali_oss+children_item.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+children_item.question_img})">
											</p>
											<dl class="pr" v-if="children_item.type=='single'">
                		    		            <div class="mask"></div>
												<el-form-item v-for="(chObj,ch_index) in children_item.choices" :key="ch_index">
													<el-radio-group v-model="children_item.exam_answer.answer" >
														<el-radio :label="chObj.flag">{{chObj.flag+'. '+chObj.content}}</el-radio>
													</el-radio-group>
												</el-form-item>
											</dl>
											<dl class="pr" v-if="children_item.type=='multiple'">
                		    		            <div class="mask"></div>
												<el-form-item>
													<el-checkbox-group v-model="children_item.value">
														<el-checkbox v-for="(chObj,ch_index) in children_item.choices" :key="ch_index" :label="chObj.flag" :name="children_item.type+index+ch_index">{{chObj.flag+'. '+chObj.content}}</el-checkbox>
													</el-checkbox-group>
												</el-form-item>
											</dl>
											<dl class="pr" v-if="children_item.type=='judgement'">
                		    		            <div class="mask"></div>
												<el-form-item>
													<el-radio-group v-model="children_item.exam_answer.answer">
														<el-radio label="对"></el-radio>
														<el-radio label="错"></el-radio>
													</el-radio-group>
												</el-form-item>
											</dl>
											<dl v-if="children_item.type=='fill'">
												<span class="zhengque" style="margin-right: 8px;border-radius: 3px;font-size: 14px;padding: 2px 5px;background-color: rgb(109, 167, 226);color: rgb(255, 255, 255);">考生回答</span>{{children_item.exam_answer.answer}}
											</dl>
											<dl v-if="children_item.type=='open'">
												<el-form-item>
													<el-input type="textarea" v-model="children_item.exam_answer.answer" autocomplete="off" readonly></el-input>
												</el-form-item>
											</dl>
											<div v-if="children_item.exam_img.length!=0">
												<span class="zhengque">考生图片</span>
												<img :src="ali_oss+img.user_img" alt="" v-for="(img,imgind) in children_item.exam_img" :key="imgind" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+img.user_img})">
											</div>
											<div class="daan" v-if="children_item.type=='fill'||children_item.type=='other1'||children_item.type=='other2'"><span class="zhengque">正确答案</span>{{children_item.correct_answer.replace(/\|\|/g,"、")}}</div>
                		    		        <div class="daan" v-else><span class="zhengque">正确答案</span>{{children_item.correct_answer}}</div>
											<img v-if="children_item.answer_img!=''" :src="ali_oss+children_item.answer_img" alt=""  @click.prevent.stop="handlePictureCardPreview({url:ali_oss+children_item.answer_img})">
											<div class="daan" v-if="children_item.answer.analysis!=''"><span class="zhengque">答案解析</span>{{children_item.answer.analysis}}</div>
											<div v-if="children_item.analyses.length" class="analyses_video">
												<div v-for="(analys_item,analys_i) in children_item.analyses" :key="analys_i">
													<!-- :poster="analys_item.video.poster" -->
													<video style="width: 80%; margin: 30px 0;" controls>
    												    <source
    												        :src="analys_item.video.url"
    												        type="video/mp4">
    												    您的浏览器不支持视频标签。
    												</video>
												</div>
											</div>
											<div class="defen" v-if="children_item.type=='fill'||children_item.type=='other1'||children_item.type=='other2'||children_item.type=='open'"><span class="defenspan">得分</span>{{children_item.exam_answer.user_score|user_score_text}}<el-button @click="notify(children_item)" type="warning" size="mini" class="notify"><i class="iconfont">&#xe63c;</i>反馈</el-button></div>
                		    		        <div class="defen" v-else><span class="defenspan">得分</span>{{children_item.exam_answer.user_score}}<el-button @click="notify(children_item)" type="warning" size="mini" class="notify"><i class="iconfont">&#xe63c;</i>反馈</el-button></div>
											<div class="daan" v-if="children_item.exam_answer.opinion!=''"><span class="zhengque">批改意见</span>{{children_item.exam_answer.opinion}}</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-form>
		</div>
		<div class="exerciseCon">
			<div class="btn_box">
				<div class="error_btn" v-if="exercise_query.result == '' ? true : false" @click="test_err('error')"><i class="iconfont">&#xe61a;</i>错题解析</div>
				<div class="all_btn" v-if="exercise_query.result == '0,2' " @click="test_err('all')"><i class="iconfont">&#xe61a;</i>全部解析</div>
				<div class="again_btn" @click="test_again"><i class="iconfont">&#xe7db;</i>再测一次</div>
			</div>
		</div>
		<div class="timeCalculationBox err">
			<div class="timeBox">用时：{{timeCal}}</div>
			<div class="timu_scroll">
				<ul>
					<li v-for="(item,index) in formal" :key="index" v-if="item.list && item.list.length >= 1">
						<div v-if="item.type != 'universal'">
							<h2>{{item.headline == "" ? big_qs_tit_txt(item.type) : item.headline}}</h2>
							<dl>
								<dd v-for="(obj,numindex) in testForm[index]" :class="time_cal_class(obj)" :key="numindex" @click="scrollFn(item.type+index+numindex)">{{numindex+1}}</dd>
							</dl>
						</div>
						<div v-else style="margin-top:10px;">
							<h2>{{item.headline == "" ? big_qs_tit_txt('universal') : item.headline}}</h2>
							<dl v-for="(un,un_idx) in item.list" :key="un_idx">
								<dd v-for="(un_obj, un_obj_idx) in un.children" :key="un_obj_idx" :class="time_cal_class(un_obj,'universal')" @click="scrollFn(testForm_universal[un_obj.unive_i][un_obj.id].click_str)">
									{{un_obj.universal_sort}}
								</dd>
							</dl>
						</div>
					</li>
				</ul>
			</div>
			<ul class="tips">
				<li>正确</li>
				<li>错误</li>
			</ul>
		</div>
		<el-dialog
			class="question_preview"
			title=""
			width="intial"
			:visible.sync="question_preview_visible" center>
			<span slot="footer" class="dialog-footer"><img :src="preview_img_src"></span>
		</el-dialog>
		<el-dialog title="反馈" :visible.sync="dialog_feedback">
		  	<el-form>
				<el-input type="textarea" v-model="feedbackCreated_content.content" :rows="4" autocomplete="off"></el-input>
		  	  	<!-- <el-form-item label="活动名称" :label-width="120">
		  	  	  	
		  	  	</el-form-item> -->
		  	</el-form>
		  	<div slot="footer" class="dialog-footer">
		  	  	<el-button @click="dialog_feedback = false">取 消</el-button>
		  	  	<el-button type="primary" @click="notify_click()">确 定</el-button>
		  	</div>
		</el-dialog>
		<el-dialog
			class="question_preview"
			title=""
			width="intial"
			:visible.sync="question_preview_visible" center>
			<span slot="footer" class="dialog-footer"><img :src="preview_img_src"></span>
		</el-dialog>
	</el-container>
</template>

<script>
let token, serverSrc, qianzui;
export default {
	name: 'test'
	,data () {
		let formal={
			single:{	 //单选题
				headline: "单选题",
				list: [],
			},
			multiple:{		//多选题
				headline: "多选题",
				list:[],
			},
			judgement:{		//判断题
				headline: "判断题",
				list:[],
			},
			fill:{		//填空题
				headline: "填空题",
				list:[],
			},
			open:{		//主观题
				headline: "主观题",
				list:[],
			},
			other1:{
				headline: "名词解析",
				list:[]
			},
			other2:{
				headline: "论述分析题",
				list:[]
			},
			universal:{
				headline: "大题",
				list:[]
			}
		}

		return {
			//获取页面get值
			exercise_query: {
				result:''
			},
			//页面参数
			ali_oss:this.global.oss_link,
			timuleixing:{single:'单选题',multiple:'多选',judgement:'判断题',fill:'填空题',open:'问答题',other1:'名词解释',other2:'论述分析题',},
			time_cal_show:false,
			test_load:true,
            asd:['A','B'],
			page_location:[],
			location:[{
				title:"首页",
				router:"/web/" + this.$store.state.defaultIndex,
				name: this.$store.state.defaultIndex,
			},{
				title:"我的课程",
				router:"/web/courseInfo/",
				name: 'courseInfo',
				activeIndex: 'index',
				query:{courseId:this.$route.query.courseId}
			},{
				title:"题库练习",
				router:"/web/courseInfo/",
				name: 'courseInfo',
				activeIndex: 'index',
				query:{
					courseId:this.$route.query.courseId,
					menuBox:'tiku',
				}
			}],
			location2:[{
				title:"首页",
				router:"/web/" + this.$store.state.defaultIndex,
				name: this.$store.state.defaultIndex,
			},{
				title:"我的作业",
				router:"/web/zuoye/",
				name: 'zuoye',
				activeIndex: 'zuoye'
			}],
			test_tit:'',
			test_fen:0,
			test_exam:0,
            fenshu:'',
			testForm:{
				single:[],
				multiple:[],
				judgement:[],
				fill:[],
				open:[],
			},
			formal:formal,
			timeCal:"0:00:00",
			//图片预览
			question_preview_visible:false,
			preview_img_src:'',
			//反馈内容
			feedbackCreated_content:{
				content:'',
				target_id:''
			},
			//反馈弹窗
			dialog_feedback:false,
			universal_sort:0,
			question_preview_visible:false,
			preview_img_src:'',
			universal_sort_arr:[]
		}
	}
	,mounted:function(){
		token=this.$cookies.get("token")
		serverSrc=this.global.serverSrc
		qianzui=this.global.qianzui
			
		let type = this.$route.query.type
		// 判断使用哪个位置
		if(type == "exercises"){
			this.page_location = this.location2
			// this.test_load = false
		}else{
			this.page_location = this.location
		}
		//获取试题信息
		this.get_userLog()
	}
	,methods:{
		//获取试题信息
		get_userLog(params){
			params = params ? params : this.$route.query
			this.exercise_query = params

			let url = serverSrc + qianzui + "/exercises/userLog"
			let that=this, question_info
			this.test_load = true				//页面进入加载模式
			this.$ajax.get(url,{
				params:params
			})
			.then(function(res){
				// console.log(res);
				let resData=res.data
				
				if(resData.code==0){
					question_info = resData.data

					document.title = question_info.title + '题库题目解析' + that.$store.state.titleAfter			//动态设置标题

					that.test_load = false
					that.test_tit = question_info.title
					that.formal = question_info.question
					// for (const key in question_info.question) {
					// 	that.formal[key] = question_info.question[key]
					// }
					that.fenshu = question_info.log.score
					that.timeCal = that.$selfjs.secondsFormat(question_info.log.use_time, {format:"H:M:S"})


					for (let j = 0; j < that.formal.length; j++) {
						let tiNnum=that.formal[j].list.length,
							tiArr=[],
							form_obj = that.formal[j]
						for(let t=0;t<tiNnum;t++){
							let qs_obj = form_obj.list[t]
							let tiId = qs_obj.id,
								tianArr = []
							if(form_obj.type == "fill"){
								for(let f=0;f<qs_obj.fill_count;f++){
									tianArr.push("")
								}
							}
							tiArr.push({"question_id":tiId, "answer":tianArr, user_score: qs_obj.exam_answer.user_score})
						}
						that.testForm[j] = tiArr
						if(form_obj.type == "multiple"){
							form_obj.list.map(function(v,i,arr){
								if(v.exam_answer.answer.length==1){
									v.value=[v.exam_answer.answer]
								}else{
									v.value=v.exam_answer.answer.split("、")
								}
							}) 
						}
						if(form_obj.type == "fill"){
							form_obj.list.forEach(function(v,i,arr){
								v.value=v.exam_answer.answer.split("||")
								// console.log(that.formal.fill[i].value);
								form_obj.list[i].value.forEach(function(v2,i2,arr2){
									form_obj.list[i].value[i2]={
										daan:v2
									}
								})
							}) 
						}
						if(form_obj.type == "universal"){
							for (let i = 0; i < form_obj.list.length; i++) {
								let uni_obj = form_obj.list[i]
								for (let l = 0; l < uni_obj.children.length; l++) {
									that.universal_sort++
									form_obj.list[i].children[l].universal_sort = that.universal_sort
									form_obj.list[i].children[l].click_str = 'universal'+i+l
									that.universal_sort_arr.push(form_obj.list[i].children[l])
									if(uni_obj.children[l].type=='multiple'){
										if(uni_obj.children[l].exam_answer.answer.length==1){
											uni_obj.children[l].value=[v.exam_answer.answer]
										}else{
											uni_obj.children[l].value=uni_obj.children[l].exam_answer.answer.split("、")
										}
									}
									// if(uni_obj.type=='fill'){
									// 	uni_obj.value=uni_obj.exam_answer.answer.split("||")
                					// 	// console.log(that.formal.fill[i].value);
                					// 	uni_obj.value.forEach(function(v2,i2,arr2){
                					// 	    that.formal.list.fill[i].value[i2]={
                					// 	        daan:v2
                					// 	    }
                					// 	})
									// }
								}
							}
						}
						
					}

					// console.log(that.formal);
					
					
					that.$nextTick(function(){
						$(".is-disabled").removeClass("is-disabled")

						let cal=$(".timeCalculationBox"),
							calTop=cal.offset().top,
							calLeft=cal.offset().left
						$(window).scroll(function(){
							if($(document).scrollTop() > 0){
								cal.addClass("pfx").css({
									top:calTop,
									left:calLeft-3
								})
							}else{
								cal.removeClass("pfx").removeAttr("style");
							}
						})
					})
				}else{
					that.$message.error('无考试信息');
				}
			})
		},
		// 查看大图
		handlePictureCardPreview(file) {
			this.question_preview_visible = true
			this.preview_img_src = this.ali_oss + file
		},
		jumpPage(args){
			this.$selfjs.jumpPage(this, args)
		},
		big_qs_tit_txt(t){
			let c;
			switch (t) {
				case "single":
					c="单选题"
					break;
				case "multiple":
					c="多选题"
					break;
				case "judgement":
					c="判断题"
					break;
				case "fill":
					c="填空题"
					break;
				case "open":
					c="主观题"
					break;
			}
			return c;
		},
		//页面滚动
		scrollFn(cla){
			$("html,body").animate({
				scrollTop:$('.'+cla).offset().top-100
			})
		},
		//悬浮框高亮样式
		time_cal_class(obj){
			// return ''
			let cla=''
			if(!parseInt(obj.user_score)){
				cla = 'err'
			}
			return cla
		},
		//再测一次
		test_again(){
			this.global.join_kaoshi.switch = true
			let data = {
				courseId: this.exercise_query.courseId,
				type: this.exercise_query.type,
				type_id: this.exercise_query.type_id,
				test_id: this.exercise_query.test_id,
			}
			this.$router.push({
				path: '/web/courseInfo/exercise',
				name: 'exercise',
				query: data,
				params: ''
			})
		},
		//题目解析
		test_err(type){
			let data = this.exercise_query
			data.result = 0

			if(type == 'error'){
				data.result = '0,2'
			}else if(type == 'all'){
				data.result = ''
			}
			//页面滚动到顶部
			document.scrollingElement.scrollTop = 0
			//更新试题信息
			this.get_userLog(data)
		},
		//反馈
		notify(item){
			this.dialog_feedback = true
			this.feedbackCreated_content.content = ''
			this.feedbackCreated_content.target_id = item.id
			// console.log(item);
		},
		//提交反馈
		notify_click(){
			const loading = this.$loading({
        	  	lock: true,
        	  	text: 'Loading',
        	  	spinner: 'el-icon-loading',
        	  	background: 'rgba(0, 0, 0, 0.7)'
        	});
			let token = this.$cookies.get("token")
			let url = this.global.serverSrc+this.global.qianzui+'/feedback';
			this.$ajax.post(url,
				this.$qs.stringify({
					title: this.test_tit,
					target_type:1,
					target_id:this.feedbackCreated_content.target_id,
					content:this.feedbackCreated_content.content
				})).then(res => {
				let resData=res.data;
				// this.loading = false
				if(resData.code==0){
					// 已购课程列表
					this.$message.success('反馈成功');
					this.dialog_feedback = false
					loading.close();
				}else if(resData.code==401){
					this.$message.error('请求错误');
					loading.close();
				}else{
					this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
					loading.close();
				}
			})
		},
		// handlePictureCardPreview(file) {
		// 	// console.log(file);
		// 	// console.log('点击了预览按钮')
		// 	this.question_preview_visible = true
		// 	this.preview_img_src = file.url
		// },
	},
	filters:{
		user_score_text(val){
			let res = val
			if(val == 0){
				res = '主观题不自动评分，请参考答案解析。'
			}
			return res
		}
	},
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
#index{background:#f4f4f4;}
.zhengque{
	margin-top: 5px;
    margin-right: 8px;
    border-radius: 3px;
    font-size: 14px;
    padding: 2px 5px;
    background-color: rgb(109, 167, 226);
    color: rgb(255, 255, 255);
}
.daan{
    margin-top: 10px;
    font-size: 16px;
	word-wrap:break-word;
}
.defen{
    margin-top: 10px;
    font-size: 16px;
}
.defenspan{
    margin-right: 8px;
    border-radius: 3px;
    font-size: 14px;
    padding: 2px 5px;
    background-color: #76d963;
    color: rgb(255, 255, 255);
}
/* .el-radio__input.is-disabled .el-radio__inner::after{
    background-color:#409EFF
} */
 .mask{
    position:absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
 }
 .pr{
     position: relative;
	 
 }
 .sp{
	color: #333 !important; 
    margin-left: 0 !important;
	display: inline-block;
    width: 100%;
    word-wrap: break-word;
 }
</style>


// WEBPACK FOOTER //
// src/components/course_info/exercise_err.vue